import graphqlClient from '~/graphql/graphqlClient';
import type { ItemLocationInput, ItemMoveResult } from './mutationPlaceItemInGlobalInventory';

const mutation = `
mutation PlaceItemInHeroInventory(
  $playerId: String!
  $itemId: String!
  $from: ItemLocationInput!
  $to: ItemLocationInput!
) {
  placeItemInHeroInventory(
    playerId: $playerId
    itemId: $itemId
    from: $from
    to: $to
  ) {
    inventory
    heroRoster
  }
}
`;

export type PlaceItemInHeroInventoryArgs = {
  playerId: string;
  itemId: string;
  from: ItemLocationInput;
  to: ItemLocationInput;
};

export default async function mutationPlaceItemInHeroInventory(
  args: PlaceItemInHeroInventoryArgs
): Promise<ItemMoveResult> {
  return await graphqlClient.request<ItemMoveResult>(
    'placeItemInHeroInventory',
    mutation,
    args
  );
}
